import type { L } from '../types/i18n'

export interface HoursRow {
  days: L
  time: L
  closed?: boolean
}

export const business = {
  name: 'A&J Auto Repair LLC',
  shortName: 'A&J Auto Repair',
  address: '910 Pulaski Hwy',
  cityState: 'Havre De Grace, MD 21078',
  city: 'Havre de Grace',
  state: 'Maryland',
  phoneDisplay: '(410) 942-5091',
  phoneHref: 'tel:+14109425091',
  smsHref: 'sms:+14109425091',
  whatsappHref: 'https://wa.me/14109425091',
  email: 'service@ajautorepairdmd.com',
  rating: 4.8,
  reviewCount: 25,
  logoUrl:
    'https://cdn.magicpatterns.com/uploads/d6H5FVEkbA5AWkNsb5uTSi/Logo_AJ_Autorepair.png',
  bannerUrl:
    'https://cdn.magicpatterns.com/uploads/cqZyCPNeiuGEQ1K5TuT84o/Banner_AJ_Auto_repair.jpg',
  mapEmbedUrl:
    'https://www.google.com/maps?q=910+Pulaski+Hwy,+Havre+De+Grace,+MD+21078&output=embed',
  directionsUrl:
    'https://www.google.com/maps/dir/?api=1&destination=910+Pulaski+Hwy,+Havre+De+Grace,+MD+21078',
  reviewsUrl:
    'https://www.google.com/search?q=A%26J+Auto+Repair+LLC+Havre+de+Grace+MD+reviews',
  serviceArea: {
    en: 'Harford County & surrounding areas',
    es: 'Condado de Harford y áreas cercanas',
  } as L,
  hoursSummary: {
    en: 'Mon–Sat 8:00 AM – 5:00 PM · Sunday closed',
    es: 'Lun–Sáb 8:00 AM – 5:00 PM · Domingo cerrado',
  } as L,
  hours: [
    {
      days: { en: 'Monday – Friday', es: 'Lunes – Viernes' },
      time: { en: '8:00 AM – 5:00 PM', es: '8:00 AM – 5:00 PM' },
    },
    {
      days: { en: 'Saturday', es: 'Sábado' },
      time: { en: '8:00 AM – 5:00 PM', es: '8:00 AM – 5:00 PM' },
    },
    {
      days: { en: 'Sunday', es: 'Domingo' },
      time: { en: 'Closed', es: 'Cerrado' },
      closed: true,
    },
  ] as HoursRow[],
}
